import { useSuspenseQuery } from "@tanstack/react-query";

import { tableQueryOptions } from "@/web/lib/tanstack";
import { tables } from "@tycho/web-bindings";

/**
 * Every known feature-flag key. Keep in sync with the server-side list in
 * `apps/spacetimedb/src/featureFlags/utils.ts` (`FEATURE_FLAG_KEYS`).
 */
export const FEATURE_FLAG_KEYS = [
  "LLM_TTW_COMPOSER",
  "TTW_COMPOSER",
  "LEASE_GRADER",
  // Gates TransactAPI investor-account creation. When off/missing, the investor
  // dashboard's "Create my investor account" CTA is hidden and the server
  // refuses the create. Onboarding + dashboard view are NOT gated.
  "TRANSACT_INVESTOR_ACCOUNTS",
  /** Master kill switch for the investment path — see the server-side list. */
  "TRANSACT_INVESTMENTS",
] as const;
export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[number];

/**
 * Reactively reads a server-side feature flag. Backed by the public
 * `featureFlagsView`, so it re-renders whenever an admin flips the flag.
 * Falls back to `false` when the flag row is absent (a flag is off until
 * explicitly enabled). Mirrors {@link useUser}.
 */
export function useFeatureFlag(key: FeatureFlagKey): boolean {
  const { data } = useSuspenseQuery(tableQueryOptions(tables.featureFlagsView));
  return data.find((flag) => flag.key === key)?.enabled ?? false;
}
